/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
// export const ASSET_DETAIL_SUCCESS_UPDATE = 'ASSET_DETAIL_SUCCESS_UPDATE';

// GET Contacts
export const GET_ASSET_CONTACTS = "GET_ASSET_CONTACTS";
export const GET_ASSET_CONTACTS_FAILURE = "GET_ASSET_CONTACTS_FAILURE";
export const GET_ASSET_CONTACTS_SUCCESS = "GET_ASSET_CONTACTS_SUCCESS";

// Add contacts
export const ADD_ASSET_CONTACT = "ADD_ASSET_CONTACT";
export const ADD_ASSET_CONTACT_SUCCESS = "ADD_ASSET_CONTACT_SUCCESS";
export const ADD_ASSET_CONTACT_FAILURE = "ADD_ASSET_CONTACT_FAILURE";

// update contacts
export const UPDATE_ASSET_CONTACT = "UPDATE_ASSET_CONTACT";
export const UPDATE_ASSET_CONTACT_SUCCESS = "UPDATE_ASSET_CONTACT_SUCCESS";
export const UPDATE_ASSET_CONTACT_FAILURE = "UPDATE_ASSET_CONTACT_FAILURE";

// delete contacts
export const DELETE_ASSET_CONTACT = "DELETE_ASSET_CONTACT";
export const DELETE_ASSET_CONTACT_SUCCESS = "DELETE_ASSET_CONTACT_SUCCESS";
export const DELETE_ASSET_CONTACT_FAILURE = "DELETE_ASSET_CONTACT_FAILURE";

// Get tenents
// export const GET_ASSET_TENENTS = 'GET_ASSET_TENENTS';
// export const GET_ASSET_TENENTS_FAILURE = 'GET_ASSET_TENENTS_FAILURE';
// export const GET_ASSET_TENENTS_SUCCESS = 'GET_ASSET_TENENTS_SUCCESS';

// Add tenents
// export const ADD_ASSET_TENENT = 'ADD_ASSET_TENENT';
// export const ADD_ASSET_TENENT_SUCCESS = 'ADD_ASSET_TENENT_SUCCESS';
// export const ADD_ASSET_TENENT_FAILURE = 'ADD_ASSET_TENENT_FAILURE';

// Update tenents
// export const UPDATE_ASSET_TENENT = 'UPDATE_ASSET_TENENT';
// export const UPDATE_ASSET_TENENT_SUCCESS = 'UPDATE_ASSET_TENENT_SUCCESS';
// export const UPDATE_ASSET_TENENT_FAILURE = 'UPDATE_ASSET_TENENT_FAILURE';

// delete tenents
// export const DELETE_ASSET_TENENT = 'DELETE_ASSET_TENENT';
// export const DELETE_ASSET_TENENT_SUCCESS = 'DELETE_ASSET_TENENT_SUCCESS';
// export const DELETE_ASSET_TENENT_FAILURE = 'DELETE_ASSET_TENENT_FAILURE';

// fileupload actions
// export const TOGGLE_FILE_UPLOAD_MODAL = 'TOGGLE_FILE_UPLOAD_MODAL';
// export const UPLOAD_IMAGES_TO_S3 = 'UPLOAD_IMAGES_TO_S3';
// export const UPLOAD_IMAGES_TO_S3_SUCCESS = 'UPLOAD_IMAGES_TO_S3_SUCCESS';
// export const UPLOAD_IMAGES_TO_S3_FAILURE = 'UPLOAD_IMAGES_TO_S3_FAILURE';

//csv actions
// export const UPLOAD_CSV = 'UPLOAD_CSV';
// export const UPLOAD_CSV_SUCCESS = 'UPLOAD_CSV_SUCCESS';
// export const UPLOAD_CSV_FAILURE = 'UPLOAD_CSV_FAILURE';

//cms content
export const GET_POLICY_CONTENT = "GET_POLICY_CONTENT";
export const GET_POLICY_CONTENT_SUCCESS = "GET_POLICY_CONTENT_SUCCESS";
export const GET_POLICY_CONTENT_FAILURE = "GET_POLICY_CONTENT_FAILURE";

//feedback
export const SAVE_FEEDBACK = "SAVE_FEEDBACK";
export const SAVE_FEEDBACK_SUCCESS = "SAVE_FEEDBACK_SUCCESS";
export const SAVE_FEEDBACK__FAILURE = "SAVE_FEEDBACK_FAILURE";

//  GET ACCOUNT DETAIL
export const GET_ACCOUNT_DETAIL = "GET_ACCOUNT_DETAIL";
export const GET_ACCOUNT_DETAIL_SUCCESS = "GET_ACCOUNT_DETAIL_SUCCESS";
export const GET_ACCOUNT_DETAIL_FAILURE = "GET_ACCOUNT_DETAIL_FAILURE";

//GET ACCOUNTS ACTIONS
export const GET_ACCOUNTS = "GET_ACCOUNTS";
export const GET_ACCOUNTS_SUCCESS = "GET_ACCOUNTS_SUCCESS";
export const GET_ACCOUNTS_FAILURE = "GET_ACCOUNTS_FAILUIRE";

//ADD ACCOUNT ACTIONS
export const ADD_ACCOUNT = "ADD_ACCOUNT";
export const ADD_ACCOUNT_SUCCESS = "ADD_ACCOUNT_SUCCESS";
export const ADD_ACCOUNT_FAILURE = "ADD_ACCOUNT_FAILURE";

//suggest contacts
export const SUGGEST_CONTACTS = "SUGGEST_CONTACTS";

//insurance addition
// export const TOGGLE_INSURANCE_MODAL = 'SUGGEST_CONTACTS';
// export const INSURANCE_ADDITION = 'INSURANCE_ADDITION';
// export const INSURANCE_ADDITION_SUCCESS = 'INSURANCE_ADDITION_SUCCESS';
// export const INSURANCE_ADDITION_FAILURE = 'INSURANCE_ADDITION_FAILURE';

export const ADD_BANK_TO_ASSET = "ADD_BANK_TO_ASSET";
export const ADD_BANK_TO_ASSET_SUCCESS = "ADD_BANK_TO_ASSET_SUCCESS";
export const ADD_BANK_TO_ASSET_FAILURE = "ADD_BANK_TO_ASSET_FAILURE";

export const REMOVE_BANK_FROM_ASSET = "REMOVE_BANK_FROM_ASSET";
export const REMOVE_BANK_FROM_ASSET_SUCCESS = "REMOVE_BANK_FROM_ASSET_SUCCESS";
export const REMOVE_BANK_FROM_ASSET_FAILURE = "REMOVE_BANK_FROM_ASSET_FAILURE";

// export const RESET = 'RESET';

//Transactions

export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const GET_TRANSACTIONS_SUCCESS = "GET_TRANSACTIONS_SUCCESS";
export const GET_TRANSACTIONS_FAILURE = "GET_TRANSACTIONS_FAILURE";

export const SAVE_TRANSACTIONS = "SAVE_TRANSACTIONS";
export const SAVE_TRANSACTION = "SAVE_TRANSACTION";
export const SAVE_TRANSACTIONS_FAILURE = "SAVE_TRANSACTIONS_FAILURE";
export const SAVE_TRANSACTIONS_SUCCESS = "SAVE_TRANSACTIONS_SUCCESS";

export const GET_TRANSACTIONS_FROM_BANK = "GET_TRANSACTIONS_FROM_BANK";
export const GET_TRANSACTIONS_FROM_BANK_SUCCESS =
  "GET_TRANSACTIONS_FROM_BANK_SUCCESS";
export const GET_TRANSACTIONS_FROM_BANK_FAILURE =
  "GET_TRANSACTIONS_FROM_BANK_FAILURE";

export const IMPORT_BANK_TRANSACTION = "IMPORT_BANK_TRANSACTION";
export const IMPORT_BANK_TRANSACTION_SUCCESS =
  "IMPORT_BANK_TRANSACTION_SUCCESS";
export const IMPORT_BANK_TRANSACTION_FAILURE =
  "IMPORT_BANK_TRANSACTION_FAILURE";

//MOrtgage

// export const SAVE_MORTGAGE = 'SAVE_MORTGAGE';
// export const SAVE_MORTGAGE_FAILURE = 'SAVE_MORTGAGE_FAILURE';
// export const SAVE_MORTGAGE_SUCCESS = 'SAVE_MORTGAGE_SUCCESS';

// export const GET_MORTGAGE = 'GET_MORTGAGE';
// export const GET_MORTGAGE_FAILURE = 'GET_MORTGAGE_FAILURE';
// export const GET_MORTGAGE_SUCCESS = 'GET_MORTGAGE_SUCCESS';

export const REMOVE_ACCOUNT = "REMOVE_ACCOUNT";
export const REMOVE_ACCOUNT_SUCCESS = "REMOVE_ACCOUNT_SUCCESS";
export const REMOVE_ACCOUNT_FAILURE = "REMOVE_ACCOUNT_FAILURE";

export const RESEND_EMAIL = "RESEND_EMAIL";
export const RESEND_EMAIL_SUCCESS = "RESEND_EMAIL_SUCCESS";
export const RESEND_EMAIL_FAILURE = "RESEND_EMAIL_FAILURE";

export const SAVE_ATTACHMENTS = "SAVE_ATTACHMENTS";
export const SAVE_ATTACHMENTS_SUCCESS = "SAVE_ATTACHMENTS_SUCCESS";
export const SAVE_ATTACHMENTS_FAILURE = "SAVE_ATTACHMENTS_FAILURE";

export const GET_ATTACHMENTS = "GET_ATTACHMENTS";
export const GET_ATTACHMENTS_SUCCESS = "GET_ATTACHMENTS_SUCCESS";
export const GET_ATTACHMENTS_FAILURE = "GET_ATTACHMENTS_FAILURE";

export const ADD_ATTACHMENT_TAGS = "ADD_ATTACHMENT_TAGS";
export const ADD_ATTACHMENT_TAGS_SUCCESS = "ADD_ATTACHMENT_TAGS_SUCCESS";
export const ADD_ATTACHMENT_TAGS_FAILURE = "ADD_ATTACHMENT_TAGS_FAILURE";

//get csv transaction
export const GET_CSV_TRANSACTIONS = "GET_CSV_TRANSACTIONS";
export const GET_CSV_TRANSACTIONS_SUCCESS = "GET_CSV_TRANSACTIONS_SUCCESS";
export const GET_CSV_TRANSACTIONS_FAILURE = "GET_CSV_TRANSACTIONS_FAILURE";

export const GET_ATTACHMENT_URL = "GET_ATTACHMENT_URL";
export const GET_ATTACHMENT_URL_SUCCESS = "GET_ATTACHMENT_URL_SUCCESS";
export const GET_ATTACHMENT_URL_FAILURE = "GET_ATTACHMENT_URL_FAILURE";

export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";
export const DELETE_ATTACHMENT_SUCCESS = "DELETE_ATTACHMENT_SUCCESS";
export const DELETE_ATTACHMENT_FAILURE = "DELETE_ATTACHMENT_FAILURE";

//notifications
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAILURE = "GET_NOTIFICATIONS_FAILURE";

// notifications
// export const MARK_NOTI_AS_COMPLETED = 'MARK_NOTI_AS_COMPLETED';
// export const MARK_NOTI_AS_COMPLETED_SUCCESS = 'MARK_NOTI_AS_COMPLETED_SUCCESS';
// export const MARK_NOTI_AS_COMPLETED_FAILURE = 'MARK_NOTI_AS_COMPLETED_FAILURE';

//Tax
// export const SET_TAX_DUE_DATE = 'SET_TAX_DUE_DATE';
// export const SET_TAX_DUE_DATE_SUCCESS = 'SET_TAX_DUE_DATE_SUCCESS';
// export const SET_TAX_DUE_DATE_FAILURE = 'SET_TAX_DUE_DATE_FAILURE';

//SideBar
export const CHANGE_SIDEBAR_VISIBILITY = "CHANGE_SIDEBAR_VISIBILITY";
export const CHANGE_MOBILE_SIDEBAR_VISIBILITY =
  "CHANGE_MOBILE_SIDEBAR_VISIBILITY";

export const SET_ASSET_SLUG = "SET_ASSET_SLUG";

//GET_BASIC_INFO
export const GET_ASSET_BASIC_INFO_SUCCESS = "GET_ASSET_BASIC_INFO_SUCCESS";
export const GET_ASSET_BASIC_INFO_FAILURE = "GET_ASSET_BASIC_INFO_FAILURE";
export const GET_ASSET_BASIC_INFO = "GET_ASSET_BASIC_INFO";

//UPDATE BASIC INFO
export const UPDATE_ASSET_BASIC_INFO = "UPDATE_ASSET_BASIC_INFO";
export const UPDATE_ASSET_BASIC_INFO_SUCCESS =
  "UPDATE_ASSET_BASIC_INFO_SUCCESS";
export const UPDATE_ASSET_BASIC_INFO_FAILURE =
  "UPDATE_ASSET_BASIC_INFO_FAILURE";

//GET_INVESTMENT_INFO
export const GET_ASSET_INVESTMENT_INFO_SUCCESS =
  "GET_ASSET_INVESTMENT_INFO_SUCCESS";
export const GET_ASSET_INVESTMENT_INFO_FAILURE =
  "GET_ASSET_INVESTMENT_INFO_FAILURE";
export const GET_ASSET_INVESTMENT_INFO = "GET_ASSET_INVESTMENT_INFO";

//UPDATE INVESTMENT INFO
export const UPDATE_ASSET_INVESTMENT_INFO_SUCCESS =
  "UPDATE_ASSET_INVESTMENT_INFO_SUCCESS";
export const UPDATE_ASSET_INVESTMENT_INFO_FAILURE =
  "UPDATE_ASSET_INVESTMENT_INFO_FAILURE";
export const UPDATE_ASSET_INVESTMENT_INFO = "UPDATE_ASSET_INVESTMENT_INFO";

//ADD FINANCIAL
export const ADD_FINANCIAL_TO_ASSET = "ADD_FINANCIAL_TO_ASSET";
export const ADD_FINANCIAL_TO_ASSET_SUCCESS = "ADD_FINANCIAL_TO_ASSET_SUCCESS";
export const ADD_FINANCIAL_TO_ASSET_FAILURE = "ADD_FINANCIAL_TO_ASSET_FAILURE";

//GET FINANCIAL
export const GET_ASSET_FINANCIALS = "GET_ASSET_FINANCIALS";
export const GET_ASSET_FINANCIALS_SUCCESS = "GET_ASSET_FINANCIALS_SUCCESS";
export const GET_ASSET_FINANCIALS_FAILURE = "GET_ASSET_FINANCIALS_FAILURE";

export const UPDATE_ASSET_FINANCIAL = "UPDATE_ASSET_FINANCIAL";
export const UPDATE_ASSET_FINANCIAL_SUCCESS = "UPDATE_ASSET_FINANCIAL_SUCCESS";
export const UPDATE_ASSET_FINANCIAL_FAILURE = "UPDATE_ASSET_FINANCIAL_FAILURE";

//GET ASSET EXPENSES
export const GET_ASSET_EXPENSES = "GET_ASSET_EXPENSES";
export const GET_ASSET_EXPENSES_SUCCESS = "GET_ASSET_EXPENSES_SUCCESS";
export const GET_ASSET_EXPENSES_FAILURE = "GET_ASSET_EXPENSES_FAILURE";

//GET ASSET INCOMES
export const GET_ASSET_INCOMES = "GET_ASSET_INCOMES";
export const GET_ASSET_INCOMES_SUCCESS = "GET_ASSET_INCOMES_SUCCESS";
export const GET_ASSET_INCOMES_FAILURE = "GET_ASSET_INCOMES_FAILURE";

//GET ASSET VALUATION
export const GET_ASSET_VALUATION = "GET_ASSET_VALUATION";
export const GET_ASSET_VALUATION_SUCCESS = "GET_ASSET_VALUATION_SUCCESS";
export const GET_ASSET_VALUATION_FAILURE = "GET_ASSET_VALUATION_FAILURE";

//GET ASSET CASHFLOW
export const GET_ASSET_CASHFLOW = "GET_ASSET_CASHFLOW";
export const GET_ASSET_CASHFLOW_SUCCESS = "GET_ASSET_CASHFLOW_SUCCESS";
export const GET_ASSET_CASHFLOW_FAILURE = "GET_ASSET_CASHFLOW_FAILURE";

//UPDATE TRANSACTION
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";
export const UPDATE_TRANSACTION_SUCCESS = "UPDATE_TRANSACTION_SUCCESS";
export const UPDATE_TRANSACTION_FAILURE = "UPDATE_TRANSACTION_FAILURE";

//DELETE TRANSACTION
export const DELETE_TRANSACTION = "DELETE_TRANSACTION";
export const DELETE_TRANSACTION_SUCCESS = "DELETE_TRANSACTION_SUCCESS";
export const DELETE_TRANSACTION_FAILURE = "DELETE_TRANSACTION_FAILURE";

//DELETE Multi TRANSACTION
export const DELETE_MULTI_TRANSACTION = "DELETE_MULTI_TRANSACTION";
export const DELETE_MULTI_TRANSACTION_SUCCESS =
  "DELETE_MULTI_TRANSACTION_SUCCESS";
export const DELETE_MULTI_TRANSACTION_FAILURE =
  "DELETE_MULTI_TRANSACTION_FAILURE";

export const GET_ASSET_MONTHWISE_INCOMES = "GET_ASSET_MONTHWISE_INCOMES";
export const GET_ASSET_MONTHWISE_INCOMES_FAILURE =
  "GET_ASSET_MONTHWISE_INCOMES_FAILURE";
export const GET_ASSET_MONTHWISE_INCOMES_SUCCESS =
  "GET_ASSET_MONTHWISE_INCOMES_SUCCESS";

export const GET_ASSET_MONTHWISE_EXPENSES = "GET_ASSET_MONTHWISE_EXPENSES";
export const GET_ASSET_MONTHWISE_EXPENSES_SUCCESS =
  "GET_ASSET_MONTHWISE_EXPENSES_SUCCESS";
export const GET_ASSET_MONTHWISE_EXPENSES_FAILURE =
  "GET_ASSET_MONTHWISE_EXPENSES_FAILURE";

export const GET_RECOMMENDATIONS = "GET_RECOMMENDATIONS";
export const GET_RECOMMENDATIONS_SUCCESS = "GET_RECOMMENDATIONS_SUCCESS";
export const GET_RECOMMENDATIONS_FAILURE = "GET_RECOMMENDATIONS_FAILURE";

// export const GET_EVENTS = 'GET_EVENTS';
// export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
// export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';

// export const GET_VIDEOS = 'GET_VIDEOS';
// export const GET_VIDEOS_SUCCESS = 'GET_VIDEOS_SUCCESS';
// export const GET_VIDEOS_FAILURE = 'GET_VIDEOS_FAILURE';

export const GET_RESOURCES = "GET_RESOURCES";
export const GET_RESOURCES_SUCCESS = "GET_RESOURCES_SUCCESS";
export const GET_RESOURCES_FAILURE = "GET_RESOURCES_FAILURE";

export const GET_MONTHLY_OVERALL_CASHFLOW = "GET_MONTHLY_OVERALL_CASHFLOW";
export const GET_MONTHLY_OVERALL_CASHFLOW_SUCCESS =
  "GET_MONTHLY_OVERALL_CASHFLOW_SUCCESS";
export const GET_MONTHLY_OVERALL_CASHFLOW_FAILURE =
  "GET_MONTHLY_OVERALL_CASHFLOW_FAILURE";

export const GET_TOTAL_MONTHLY_STATS = "GET_TOTAL_MONTHLY_STATS";
export const GET_TOTAL_MONTHLY_STATS_SUCCESS =
  "GET_TOTAL_MONTHLY_STATS_SUCCESS";
export const GET_TOTAL_MONTHLY_STATS_FAILURE =
  "GET_TOTAL_MONTHLY_STATS_FAILURE";

export const GET_DASHBOARD_STATS = "GET_DASHBOARD_STATS";
export const GET_DASHBOARD_STATS_SUCCESS = "GET_DASHBOARD_STATS_SUCCESS";
export const GET_DASHBOARD_STATS_FAILURE = "GET_DASHBOARD_STATS_FAILURE";

export const GET_ASSET_STATS = "GET_ASSET_STATS";
export const GET_ASSET_STATS_SUCCESS = "GET_ASSET_STATS_SUCCESS";
export const GET_ASSET_STATS_FAILURE = "GET_ASSET_STATS_FAILURE";

export const EXPORT_TO_EXCEL_SUCCESS = "EXPORT_TO_EXCEL_SUCCESS";
export const EXPORT_TO_EXCEL_FAILURE = "EXPORT_TO_EXCEL_FAILURE";
export const EXPORT_TO_EXCEL = "EXPORT_TO_EXCEL";

export const RUN_REPORT_SUCCESS = "RUN_REPORT_SUCCESS";
export const RUN_REPORT_FAILURE = "RUN_REPORT_FAILURE";
export const RUN_REPORT = "RUN_REPORT";

export const GET_MONTHLY_GRAPH = "GET_MONTHLY_GRAPH";
export const GET_MONTHLY_GRAPH_SUCCESS = "GET_MONTHLY_GRAPH_SUCCESS";
export const GET_MONTHLY_GRAPH_FAILURE = "GET_MONTHLY_GRAPH_FAILURE";

export const GET_YEARLY_GRAPH = "GET_YEARLY_GRAPH";
export const GET_YEARLY_GRAPH_SUCCESS = "GET_YEARLY_GRAPH_SUCCESS";
export const GET_YEARLY_GRAPH_FAILURE = "GET_YEARLY_GRAPH_FAILURE";

export const GET_CASHFLOW_GRAPH = "GET_CASHFLOW_GRAPH";
export const GET_CASHFLOW_GRAPH_SUCCESS = "GET_CASHFLOW_GRAPH_SUCCESS";
export const GET_CASHFLOW_GRAPH_FAILURE = "GET_CASHFLOW_GRAPH_FAILURE";

export const SAVE_REDIRECT = "SAVE_REDIRECT";

export const SET_CONTACT_TO_ADD = "SET_CONTACT_TO_ADD";

export const DOWNLOAD_SAMPLE_CSV = "DOWNLOAD_SAMPLE_CSV";
export const MARK_ALL_PAID = "MARK_ALL_PAID";
export const REMOVE_ALL_DUPLICATES = "REMOVE_ALL_DUPLICATES";

export const DOWNLOAD_PAST_SAMPLE_XLSX = "DOWNLOAD_PAST_SAMPLE_XLSX";

export const GET_ALL_CONTACTS = "GET_ALL_CONTACTS";
export const GET_ALL_CONTACTS_SUCCESS = "GET_ALL_CONTACTS_SUCCESS";

export const INVITE_USER = "INVITE_USER";
export const INVITE_USER_SUCCESS = "INVITE_USER_SUCCESS";
export const INVITE_USER_FAILURE = "INVITE_USER_FAILURE";

export const ADD_DEAL = "ADD_DEAL";
export const ADD_DEAL_SUCCESS = "ADD_DEAL_SUCCESS";
export const ADD_DEAL_FAILURE = "ADD_DEAL_FAILURE";

export const GET_DEALS = "GET_DEALS";
export const GET_DEALS_SUCCESS = "GET_DEALS_SUCCESS";
export const GET_DEALS_FAILURE = "GET_DEALS_FALIURE";

export const RESERVE_RESOURCE = "RESERVE_RESOURCE";
export const RESERVE_RESOURCE_SUCCESS = "RESERVE_RESOURCE_SUCCESS";
export const RESERVE_RESOURCE_FAILURE = "RESERVE_RESOURCE_FAILURE";

export const GET_DEAL_LISTING = "GET_DEAL_LISTING";
export const GET_DEAL_LISTING_SUCCESS = "GET_DEAL_LISTING_SUCCESS";
export const GET_DEAL_LISTING_FAILURE = "GET_DEAL_LISTING_FAILURE";

export const UPDATE_INCOME_GOAL = "UPDATE_INCOME_GOAL";
export const UPDATE_INCOME_GOAL_SUCCESS = "UPDATE_INCOME_GOAL_SUCCESS";
export const UPDATE_INCOME_GOAL_FAILURE = "UPDATE_INCOME_GOAL_FAILURE";

export const GET_ASSET_CHECKLIST = "GET_ASSET_CHECKLIST";
export const GET_ASSET_CHECKLIST_SUCCESS = "GET_ASSET_CHECKLIST_SUCCESS";
export const GET_ASSET_CHECKLIST_FAILURE = "GET_ASSET_CHECKLIST_FAILURE";

export const TRANSFER_ASSET = "TRANSFER_ASSET";
export const TRANSFER_ASSET_SUCCESS = "TRANSFER_ASSET_SUCCESS";
export const TRANSFER_ASSET_FAILURE = "TRANSFER_ASSET_FAILURE";

export const POST_RESOURCE = "POST_RESOURCE";
export const POST_RESOURCE_SUCCESS = "POST_RESOURCE_SUCCESS";
export const POST_RESOURCE_FAILURE = "POST_RESOURCE_FAILURE";

export const UPDATE_RESOURCE = "UPDATE_RESOURCE";
export const UPDATE_RESOURCE_SUCCESS = "UPDATE_RESOURCE_SUCCESS";
export const UPDATE_RESOURCE_FAILURE = "UPDATE_RESOURCE_FAILURE";

export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";

export const GET_MY_RESOURCES = "GET_MY_RESOURCES";
export const GET_MY_RESOURCES_SUCCESS = "GET_MY_RESOURCES_SUCCESS";
export const GET_MY_RESOURCES_FAILURE = "GET_MY_RESOURCES_FAILURE";

export const GET_VIEW_RESOURCE = "GET_VIEW_RESOURCE";
export const GET_VIEW_RESOURCE_SUCCESS = "GET_VIEW_RESOURCE_SUCCESS";
export const GET_VIEW_RESOURCE_FAILURE = "GET_VIEW_RESOURCE_FAILURE";

export const PROPERTY_PARSE = "PROPERTY_PARSE";
export const PROPERTY_PARSE_SUCCESS = "PROPERTY_PARSE_SUCCESS";
export const PROPERTY_PARSE_FAILURE = "PROPERTY_PARSE_FAILURE";

// export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
// export const ADD_NOTIFICATION_SUCCESS = "ADD_NOTIFICATION_SUCCESS";
// export const ADD_NOTIFICATION_FAILURE = "ADD_NOTIFICATION_FAILURE";

export const GET_REMINDERS_SUCCESS = "GET_REMINDERS_SUCCESS";
export const GET_REMINDERS_FAILURE = "GET_REMINDERS_FAILURE";
export const GET_REMINDERS = "GET_REMINDERS";

export const ADD_REMINDER_SUCCESS = "ADD_REMINDER_SUCCESS";
export const ADD_REMINDER_FAILURE = "ADD_REMINDER_FAILURE";
export const ADD_REMINDER = "ADD_REMINDER";

export const UPDATE_REMINDER_SUCCESS = "UPDATE_REMINDER_SUCCESS";
export const UPDATE_REMINDER_FAILURE = "UPDATE_REMINDER_FAILURE";
export const UPDATE_REMINDER = "UPDATE_REMINDER";

export const SHOW_MISSING_IMPORT = "SHOW_MISSING_IMPORT";
export const HIDE_MISSING_IMPORT = "HIDE_MISSING_IMPORT";

export const SIGNUP_PARTNER = "SIGNUP_PARTNER";
export const SIGNUP_PARTNER_SUCCESS = "SIGNUP_PARTNER_SUCCESS";
export const SIGNUP_PARTNER_FAILURE = "SIGNUP_PARTNER_FAILURE";

export const UPDATE_PARTNER = "UPDATE_PARTNER";
export const UPDATE_PARTNER_SUCCESS = "UPDATE_PARTNER_SUCCESS";
export const UPDATE_PARTNER_FAILURE = "UPDATE_PARTNER_FAILURE";

export const GET_PARTNER = "GET_PARTNER";
export const GET_PARTNER_SUCCESS = "GET_PARTNER_SUCCESS";
export const GET_PARTNER_FAILURE = "GET_PARTNER_FAILURE";

export const ADD_ASSET_MEDIAS = "ADD_ASSET_MEDIAS";
export const ADD_ASSET_MEDIAS_SUCCESS = "ADD_ASSET_MEDIAS_SUCCESS";
export const ADD_ASSET_MEDIAS_FAILURE = "ADD_ASSET_MEDIAS_FAILURE";

export const GET_ASSET_MEDIAS = "GET_ASSET_MEDIAS";
export const GET_ASSET_MEDIAS_SUCCESS = "GET_ASSET_MEDIAS_SUCCESS";
export const GET_ASSET_MEDIAS_FAILURE = "GET_ASSET_MEDIAS_FAILURE";

export const DELETE_ASSET_MEDIA = "DELETE_ASSET_MEDIA";
export const DELETE_ASSET_MEDIA_SUCCESS = "DELETE_ASSET_MEDIA_SUCCESS";
export const DELETE_ASSET_MEDIA_FAILURE = "DELETE_ASSET_MEDIA_FAILURE";

export const LIST_PARTNERS = "LIST_PARTNERS";
export const LIST_PARTNERS_SUCCESS = "LIST_PARTNERS_SUCCESS";
export const LIST_PARTNERS_FAILURE = "LIST_PARTNERS_FAILURE";

export const RESET_CASHFLOW_GRAPH = "RESET_CASHFLOW_GRAPH";
export const RESET_BASIC_INFO = "RESET_BASIC_INFO";
export const RESET_INVESTMENT_INFO = "RESET_INVESTMENT_INFO";
export const RESET_HAS_ASSET = "RESET_HAS_ASSET";

export const GET_OVERALL_CASHFLOW = "GET_OVERALL_CASHFLOW";
export const GET_OVERALL_CASHFLOW_SUCCESS = "GET_OVERALL_CASHFLOW_SUCCESS";
export const GET_OVERALL_CASHFLOW_FAILURE = "GET_OVERALL_CASHFLOW_FAILURE";

export const SUBMIT_TESTIMONIAL = "SUBMIT_TESTIMONIAL";
export const SUBMIT_TESTIMONIAL_SUCCESS = "SUBMIT_TESTIMONIAL_SUCCESS";
export const SUBMIT_TESTIMONIAL_FAILURE = "SUBMIT_TESTIMONIAL_FAILURE";

export const GET_ALL_DOCUMENTS = "GET_ALL_DOCUMENTS";
export const GET_ALL_DOCUMENTS_SUCCESS = "GET_ALL_DOCUMENTS_SUCCESS";
export const GET_ALL_DOCUMENTS_FAILURE = "GET_ALL_DOCUMENTS_FAILURE";

export const UPLOAD_DOCUMENTS = "UPLOAD_DOCUMENTS";
export const UPLOAD_DOCUMENTS_SUCCESS = "UPLOAD_DOCUMENTS_SUCCESS";
export const UPLOAD_DOCUMENTS_FAILURE = "UPLOAD_DOCUMENTS_FAILURE";

export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const DELETE_DOCUMENT_SUCCESS = "DELETE_DOCUMENT_SUCCESS";
export const DELETE_DOCUMENT_FAILURE = "DELETE_DOCUMENT_FAILURE";

export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";

export const RESET_DOCUMENTS = "RESET_DOCUMENTS";

export const ADD_ACCOUNT_FILTER = "ADD_ACCOUNT_FILTER";
export const ADD_ACCOUNT_FILTER_SUCCESS = "ADD_ACCOUNT_FILTER_SUCCESS";
export const ADD_ACCOUNT_FILTER_FAILURE = "ADD_ACCOUNT_FILTER_FAILURE";

export const DELETE_ACCOUNT_FILTER = "DELETE_ACCOUNT_FILTER";
export const DELETE_ACCOUNT_FILTER_SUCCESS = "DELETE_ACCOUNT_FILTER_SUCCESS";
export const DELETE_ACCOUNT_FILTER_FAILURE = "DELETE_ACCOUNT_FILTER_FAILURE";

export const GET_ACCOUNT_FILTER = "GET_ACCOUNT_FILTER";
export const GET_ACCOUNT_FILTER_SUCCESS = "GET_ACCOUNT_FILTER_SUCCESS";
export const GET_ACCOUNT_FILTER_FAILURE = "GET_ACCOUNT_FILTER_FAILURE";

export const GET_ACCOUNT_FILTERS = "GET_ACCOUNT_FILTERS";
export const GET_ACCOUNT_FILTERS_SUCCESS = "GET_ACCOUNT_FILTERS_SUCCESS";
export const GET_ACCOUNT_FILTERS_FAILURE = "GET_ACCOUNT_FILTERS_FAILURE";

export const RESET_FINANCIALS = "RESET_FINANCIALS";
export const RESET_TRANSACTIONS = "RESET_TRANSACTIONS";

export const GET_ALL_TRANSACTIONS = "GET_ALL_TRANSACTIONS";
export const GET_ALL_TRANSACTIONS_SUCCESS = "GET_ALL_TRANSACTIONS_SUCCESS";
export const GET_ALL_TRANSACTIONS_FAILURE = "GET_ALL_TRANSACTIONS_FAILURE";

export const DELETE_ASSET_FINANCIAL = "DELETE_ASSET_FINANCIAL";
export const DELETE_ASSET_FINANCIAL_SUCCESS = "DELETE_ASSET_FINANCIAL_SUCCESS";
export const DELETE_ASSET_FINANCIAL_FAILURE = "DELETE_ASSET_FINANCIAL_FAILURE";

export const GRANT_PERMISSION = "GRANT_PERMISSION";
export const GRANT_PERMISSION_SUCEESS = "GRANT_PERMISSION_SUCEESS";
export const GRANT_PERMISSION_FAILURE = "GRANT_PERMISSION_FAILURE";

export const ADD_CONTACT = "ADD_CONTACT";
export const ADD_CONTACT_SUCCESS = "ADD_CONTACT_SUCCESS";
export const ADD_CONTACT_FAILURE = "ADD_CONTACT_FAILURE";

export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS";
export const UPDATE_CONTACT_FAILURE = "UPDATE_CONTACT_FAILURE";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const DELETE_CONTACT_SUCCESS = "DELETE_CONTACT_SUCCESS";
export const DELETE_CONTACT_FAILURE = "DELETE_CONTACT_FAILURE";

export const CLOSE_ASSET = "CLOSE_ASSET";
export const CLOSE_ASSET_SUCCESS = "CLOSE_ASSET_SUCCESS";
export const CLOSE_ASSET_FAILURE = "CLOSE_ASSET_FAILURE";

export const SET_DRAWER_STATE = "SET_DRAWER_STATE";

export const REQUEST_DOCUMENT = "REQUEST_DOCUMENT";
export const REQUEST_DOCUMENT_SUCCESS = "REQUEST_DOCUMENT_SUCCESS";
export const REQUEST_DOCUMENT_FAILURE = "REQUEST_DOCUMENT_FAILURE";
